import { useEffect, useState } from 'react'

import { B2, SH3, Stack } from '@zet/design-system'
import { Button } from '@zet/design-system/button'
import { i18n } from '@zet/localization'

type ResetOtpProps = {
  locale: string
  timerCount: number
  handleSubmit: () => void
}
const ResetOtp = ({ timerCount, locale, handleSubmit }: ResetOtpProps) => {
  const [count, setCount] = useState(timerCount)

  // Countdown logic
  useEffect(() => {
    let timer = null

    if (count > 0) {
      timer = setInterval(() => {
        setCount((prevCount) => prevCount - 1)
      }, 1000)
    }

    // Clean up interval on count = 0
    if (count === 0) {
      clearInterval(timer as NodeJS.Timer)
    }

    // Clean up interval on unmount
    return () => clearInterval(timer as NodeJS.Timer)
  }, [count])

  const resetOtp = () => {
    setCount(timerCount)
    handleSubmit()
  }

  return (
    <>
      {count === 0 ? (
        <Stack className="items-center">
          <Button
            eventName="click_action"
            eventPayload={{ item_name: 'login_signup_resend_otp' }}
            textOnly={true}
            textStyle="text-primary-100"
            size={'small'}
            onPress={resetOtp}
          >
            {i18n.t('otpInput.resend')}
          </Button>
        </Stack>
      ) : (
        <Stack
          className="items-center justify-center py-1"
          style={{
            flexDirection: locale === 'hi' ? 'row-reverse' : 'row',
          }}
        >
          <B2 className="text-grays-60 text-center">
            {i18n.t('otpInput.resendOtpIn')}
          </B2>
          <SH3 className="text-primary-100">
            00:{count < 10 ? `0${count}` : count}
          </SH3>
        </Stack>
      )}
    </>
  )
}

export default ResetOtp
